// extracted by mini-css-extract-plugin
export default {"eachSkillWrapper":"EachSkillWrapperCard_eachSkillWrapper__O6eoI","skillTitle":"EachSkillWrapperCard_skillTitle__bGbaR"};